import { useQuery } from 'react-query'
import apiService from '../services/api'
import AdminLayout from '../components/AdminLayout'
import { Package, Search } from 'lucide-react'
import { useState, useEffect } from 'react'

const AdminProducts = () => {
  const [search, setSearch] = useState('')
  const { data, refetch, isLoading } = useQuery(
    ['admin-products', search],
    () => apiService.get('/rentman/products', { params: { search, limit: 50 } }).then(r => r.data),
    { keepPreviousData: true }
  )
  useEffect(() => { const t = setTimeout(() => refetch(), 300); return () => clearTimeout(t) }, [search, refetch])
  const products = data?.products || []

  return (
    <AdminLayout title="Administration" subtitle="Produits">
        <div>
          <div className="card mb-6">
            <div className="flex items-center">
              <Search className="h-4 w-4 text-gray-500 mr-2" />
              <input className="input-field" placeholder="Rechercher un produit" value={search} onChange={(e)=>setSearch(e.target.value)} />
            </div>
          </div>
          <div className="card">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="text-left py-3 px-4">ID</th>
                    <th className="text-left py-3 px-4">Nom</th>
                    <th className="text-left py-3 px-4">Catégorie</th>
                    <th className="text-left py-3 px-4">Prix/jour</th>
                    <th className="text-left py-3 px-4">Dispo</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr><td colSpan="5" className="py-12 text-center text-gray-600">Chargement…</td></tr>
                  ) : products.length === 0 ? (
                    <tr><td colSpan="5" className="py-12 text-center text-gray-600">Aucun produit</td></tr>
                  ) : (
                    products.map(p => (
                      <tr key={p.id} className="border-b border-gray-200 hover:bg-gray-50">
                        <td className="py-3 px-4">{p.id}</td>
                        <td className="py-3 px-4">{p.name}</td>
                        <td className="py-3 px-4">{p.category_name || '-'}</td>
                        <td className="py-3 px-4">{p.price_per_day || 0}€</td>
                        <td className="py-3 px-4">{p.is_available === false ? 'Non' : 'Oui'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </AdminLayout>
  )
}

export default AdminProducts


